
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class RouterGoProductDetailsBtn extends Vue {
  @Prop({ required: true })
  public readonly id!: any
}
